module.exports = __webpack_public_path__ + "static/img/materials7.93d0610.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/materials7.jpg
// module id = TtJS
// module chunks = 1